import React from 'react';
import SectionContainer from 'components/Containers/SectionContainer';
import Label from 'components/form/Label/Label';

const HeadTextSection = props => {
  const { sectionTitle, sectionParagraph } = props;
  return (
    <SectionContainer className="sectionContainer pad40 m-padTB24 m-padLR16 margB24 m-marB16">
      <Label
        typeHeader={'h4'}
        className="text-28 bold margB24 m-text-20 m-margB8"
      >
        {sectionTitle}
      </Label>
      <div className="gray7 text-16 m-text-14">{sectionParagraph}</div>
    </SectionContainer>
  );
};

export default HeadTextSection;
